import { ListItemIcon } from "@mui/material";

import { CbhIconSkeleton } from "../CbhIconSkeleton";

export function ListItemIconSkeleton() {
  return (
    <ListItemIcon>
      <CbhIconSkeleton size="medium" />
    </ListItemIcon>
  );
}
